export const LISTE_COMMANDE_TLPE = {
  title: 'Historique des déclarations TLPE',
  breadcrumb: {
    liste: 'Historique déclarations TLPE',
  },
  tab: {
    code: 'Code',
    annee: 'Année',
    declarant: 'Déclarant',
    collectivite: 'Collectivité',
    etat: 'Etat',
    typeDeclaration: 'Type de déclaration',
    adresse: 'Adresse',
    departement: 'Departement',
    ville: 'Ville',
    codePostal: 'Code postal',
    codeDossier: 'Code dossier',
    dateDeclaration: 'Date de déclaration',
    montantTtc: 'Montant TTC',
  },
  filtre: {
    code: 'Code(s)',
    annee: 'Année',
    declarant: 'Déclarant(s)',
    collectivite: 'Collectivité(s)',
    etat: 'Etat(s)',
    typeDeclaration: 'Type(s) de déclaration',
    codeDossier: 'Code(s) dossier',
    departement: 'Département(s)',
  },
  typeDeclaration: {
    declaration: 'Déclaration',
    declarationFilDeLeau: 'Fil de l\'eau',
    materielEnPlace: 'Matériel en place',
    montagesAnneePrec: 'Montage année prec.',
    demontageAnneePrec: 'Démontage année prec.',
    montageFilDeLeau: 'Montage au fil de l\'eau',
    demontageFilDeLeau: 'Démontage au fil de l\'eau',
  },
  suppression: {
    title: 'Etes-vous sûr de vouloir supprimer votre déclaration TLPE ?',
  },
  messages: {
    success: {
      suppression: 'Déclaration TLPE supprimée avec succès.',
    },
  },
};

export const DETAIL_COMMANDE_TLPE = {
  title: 'Détail déclaration TLPE {code}',
  breadcrumb: {
    liste: 'Historique déclarations TLPE',
    detail: 'Détail déclaration TLPE',
  },
  action: {
    generer: 'Re-générer déclaration TLPE',
  },
  steps: {
    infoGenerales: 'Informations générales',
    infoMateriel: 'Informations matériels',
    piecesJointes: 'Pièces jointes',
    collectivite: 'Collectivité',
    commentaire: 'Commentaires',
  },
  collectivite: {
    title: 'Collectivité',
    adresse: 'Adresse',
  },
  tabs: {
    quotation: 'Informations générales',
    echeancierTlpe: 'Echéancier',
  },
  infoGenerales: {
    title: 'Informations générales',
    annee: 'Année déclaration',
    typeDeclaration: 'Type déclaration',
    declarant: 'Déclarant',
    referenceClient: 'Référence client',
    codeDossier: 'Code dossier',
  },
  infoMateriel: {
    title: 'Informations matériels',
    lienVersMaterielTexte: 'Liste des matériels liés à la collectivité',
    tab: {
      codeMateriel: 'Code matériel',
      adresse: 'Adresse',
      descriptionTlpe: 'Description Tlpe',
      dateCreation: 'Date création',
      dateSuppression: 'Date suppression',
      dateDebut: 'Date début',
      dateFin: 'Date fin',
      numerique: 'Numérique',
      nbFace: 'Nb faces',
      superficie: 'Superficie unitaire',
      totalHt: 'Total HT',
      quantite: 'Quantité',
      prixUnitaire: 'Prix unitaire',
    },
  },
  infoCommentaire: {
    title: 'Commentaires',
    commentaireInterne: 'Commentire interne',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  generation: {
    title: 'Etes-vous sûr de vouloir re-générer votre déclaration TLPE ?',
  },
  suppression: {
    title: 'Etes-vous sûr de vouloir supprimer votre déclaration TLPE ?',
  },
  messages: {
    success: {
      generation: 'Déclaration TLPE re-générée avec succès.',
      suppression: 'Déclaration TLPE supprimée avec succès.',
    },
  },
};

export const EDIT_COMMANDE_TLPE = {
  title: 'Modifier la déclaration TLPE {code}',
  breadcrumb: {
    liste: 'Historique déclarations TLPE',
    edit: 'Modifier déclaration TLPE',
  },
  collectivite: {
    title: 'Collectivité',
  },
  tabs: {
    quotation: 'Informations générales',
    echeancierTlpe: 'Echéancier',
  },
  infoGenerales: {
    title: 'Informations générales',
    annee: 'Année déclaration',
    typeDeclaration: 'Type déclaration',
    declarant: 'Déclarant',
    referenceClient: 'Référence client',
    codeDossier: 'Code dossier',
  },
  infoMateriel: {
    title: 'Informations matériels',
    tab: {
      codeMateriel: 'Code matériel',
      adresse: 'Adresse',
      descriptionTlpe: 'Description Tlpe',
      dateCreation: 'Date création',
      dateSuppression: 'Date suppression',
      dateDebut: 'Date début',
      dateFin: 'Date fin',
      numerique: 'Numérique',
      nbFace: 'Nb faces',
      superficie: 'Superficie unitaire',
      calaculAuto: 'Calcul auto',
      quantite: 'Quantité',
      prixUnitaire: 'Prix unitaire',
      montantBrut: 'Total HT',
    },
  },
  infoCommentaire: {
    title: 'Commentaires',
    commentaireInterne: 'Commentaires interne',
  },
  messages: {
    success: {
      edit: 'Déclaration TLPE modifiée avec succès.',
    },
    error: {
      oneProduct: 'La déclaration TLPE doit contenir au moins une ligne avec un matériel',
      lineNotValidForCalc: 'Ligne invalide pour un calcul auto',
    },
  },
};
